module.exports = __webpack_public_path__ + "img/oberon.c6bf6c27.png";